import store from "@/core/store";
import {SET_ERROR_STATUS_CODE} from "@/core/store/modules/errors/constants";

export default function error({to, next, router}) {
    if (store.getters.getErrorStatusCode !== to.meta.code) {
        return router.push({name: 'home'}).catch(()=>{});
    }

    store.commit(SET_ERROR_STATUS_CODE, null)
    return next();
}